import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { PaperClipOutlined } from '@ant-design/icons';
import { Text } from '@/components/Typography';
import * as S from './styles';

export function Button(): JSX.Element {
	return (
		<Row>
			<S.IconWrapper span={24}>
				<PaperClipOutlined />
			</S.IconWrapper>
			<Col span={24}>
				<Text style={{ fontSize: '16px' }}>{I18n.get('Attach file')}</Text>
			</Col>
		</Row>
	);
}
